module.exports = __webpack_public_path__ + "static/img/BIAS-FX-2@2x.f430518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/featured/BIAS-FX-2@2x.png
// module id = +ckT
// module chunks = 13